import * as z from "zod";
import { withdrawalTimelineEventSchema } from "./get-withdrawal";

export const createWithdrawalComment = {
  name: "createWithdrawalComment" as const,
  input: z.object({
    withdrawalId: z.string(),
    message: z.string().trim().min(1),
  }),
  output: z.object({ event: withdrawalTimelineEventSchema }),
};
